import * as React from "react"
import { Toast as BSToast, ToastBody, ToastHeader, Collapse } from "reactstrap"
import { ToastContext } from "components/toast"
import "./toast.scss"

const Toast: React.FC = () => {
	const toasts = React.useContext(ToastContext)
	return (
		<div className="toast-container position-fixed d-flex flex-column p-4 ml-auto">
			{toasts.map(({ id, open, header, icon, text }) => (
				<Collapse key={id} isOpen={open}>
					<BSToast isOpen={open}>
						<ToastHeader icon={icon}>{header}</ToastHeader>
						<ToastBody>{text}</ToastBody>
					</BSToast>
				</Collapse>
			))}
		</div>
	)
}

export default Toast
